import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Menu, Popover } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../../FilterChip/FilterChip';
import { useSettingsChipTone } from '../../settingsChipTone';
import { summarizeServicePredicate } from '../../summarizeServicePredicate';
import { serviceAlternatives } from '../serviceConditionDisplay';
import { currentServiceName, isSoleNameCondition, operatorLabel, serviceNamePredicate } from './ServiceConditionChip.utils';
export const GetServiceConditionChipTID = (parentTestId)=>getTestIds(parentTestId);
export const ServiceConditionChip = (param)=>{
    let { testId, quantifier, predicate, serviceOptions = [], onToggleQuantifier, onChangePredicate, onRemove } = param;
    var _ref, _ref1;
    const { ServiceConditionChipTestIds } = useMemo(()=>GetServiceConditionChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const { t: tAddServices } = useLocaleKeys('components.addServicesButton');
    const [anchorEl, setAnchorEl] = useState(null);
    const tone = useSettingsChipTone();
    const editable = isSoleNameCondition(predicate);
    const selectedName = currentServiceName(predicate);
    const openPopover = (event)=>setAnchorEl(event.currentTarget);
    const closePopover = ()=>setAnchorEl(null);
    const select = (option)=>{
        onChangePredicate(serviceNamePredicate(option.name));
        closePopover();
    };
    const alternatives = serviceAlternatives(predicate, t);
    const useSegments = alternatives != null && alternatives.labels.length > 1;
    const valueSegments = useSegments ? alternatives.labels.map((label)=>({
            label
        })) : undefined;
    const menuItems = serviceOptions.map((option)=>({
            id: option.id,
            title: option.name,
            body: option.body,
            badge: option.isBundle ? {
                text: tAddServices.popover.bundle()
            } : undefined,
            selected: option.name === selectedName,
            bi: {
                name: 'drafts_ai_search_chip_services_option',
                data: {
                    service_template_id: option.id
                }
            },
            onClick: ()=>select(option)
        }));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: t.servicesLabel(),
                operator: {
                    label: operatorLabel(quantifier, (_ref = alternatives === null || alternatives === void 0 ? void 0 : alternatives.isHas) !== null && _ref !== void 0 ? _ref : false, t),
                    onToggle: onToggleQuantifier,
                    biName: 'drafts_ai_search_chip_toggle_services_quantifier'
                },
                valueSegments: valueSegments,
                combinator: useSegments ? t.orConnector() : undefined,
                valueLabel: useSegments ? undefined : (_ref1 = alternatives === null || alternatives === void 0 ? void 0 : alternatives.labels[0]) !== null && _ref1 !== void 0 ? _ref1 : summarizeServicePredicate(predicate, t),
                onValueClick: !useSegments && editable ? openPopover : undefined,
                onRemove: onRemove,
                removeBiName: "drafts_ai_search_chip_remove_services",
                tone: tone
            }),
            editable && /*#__PURE__*/ _jsx(Popover, {
                testId: ServiceConditionChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Menu, {
                    testId: ServiceConditionChipTestIds.Menu(),
                    dimensions: {
                        height: 344
                    },
                    emptyText: tAddServices.noMatchesFound(),
                    searchProps: {
                        showSearch: true,
                        autoFocus: true,
                        bi: {
                            name: 'drafts_ai_search_chip_services_search'
                        },
                        strategy: {
                            type: 'text'
                        }
                    },
                    items: menuItems
                })
            })
        ]
    });
};
